
// const monthsList = ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆកា", "ធ្នូ"]
const monthsList = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
// const monthsList = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]

const config = {
	api: 'https://client-api.cam99gaming.com/api/v1',
	// api: 'http://localhost:81/api/v1',
	referral: "https://98mbet.com/#/r/",
	datelify: (timestamp) => {
		let d = new Date(timestamp * 1000);
		let date = d.getDate();
		let month = d.getMonth();
		let year = d.getFullYear();
		let hour = d.getHours();
		let minute = d.getMinutes();

		let state = hour >= 12 ? "PM" : "AM";
		let paddingDate = date > 9 ? "" : "0";
		let paddingMinute = minute > 9 ? "" : "0";

		return `${paddingDate}${date}/${monthsList[month]}/${year} · ${hour}:${paddingMinute}${minute}${state}`
	},
	orderlify: (number) => {
		let length = String(number).length;
		let padding = 6 - length;
		let zeroPadding = "";
		for (let i = 0; i < padding; i++) {
			zeroPadding += "0";
		}

		return zeroPadding + number;
	},
	timelify: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (currentDate.getTime() - oldDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			return Math.floor(seconds / 31536000) + " ឆ្នាំមុន";

		} else if (seconds / 2592000 > 1) {
			return Math.floor(seconds / 2592000) + " ខែមុន";

		} else if (seconds / 86400 > 1) {
			return Math.floor(seconds / 86400) + " ថ្ងៃមុន";

		} else if (seconds / 3600 > 1) {
			return Math.floor(seconds / 3600) + " ម៉ោងមុន";

		} else if (seconds / 60 > 1) {
			return Math.floor(seconds / 60) + " នាទីមុន";

		} else {
			return "ឥឡូវនេះ";
		}

	},
	getCookie: (cname) => {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	moneylify: (total, currency = "usd") => {
		// if (Number.isNaN(total)) total = 0;
		let sign = "", currency_view_front = "", currency_view_end = "";

		if (currency == 'khr') currency_view_front = "", currency_view_end = " ៛";
		if (currency == 'usd') currency_view_front = "$", currency_view_end = "";

		total = parseInt(parseFloat(total) * 100) / 100;

		if (total < 0) {
			sign = "-";
			total = total * -1.00;
		}

		let total_real = String(parseInt(total));
		let total_rational = String((total - parseInt(total)).toFixed(2));
		// console.log()
		let output = "";
		if (total_real.length <= 3) {
			output = total_real;
		} else if (total_real.length <= 6) {
			output = total_real.slice(0, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else if (total_real.length <= 9) {
			output = total_real.slice(0, total_real.length - 6) + "," + total_real.slice(total_real.length - 6, total_real.length - 3) + "," + total_real.slice(total_real.length - 3);
		} else {
			output = total_real;
		}

		return sign + currency_view_front + output + "." + total_rational.replace("0.", "") + currency_view_end;
	},
	getExpire(timestamp) {

		let currentDay = new Date();

		let left = Math.round((timestamp * 1000 - currentDay.getTime()) / (86400000))

		return {
			value: left < 0 ? "ផុតកំណត់" : "សល់ " + left + " ថ្ងៃ",
			total: left < 0 ? 0 : left
		}
		// if (left < 0) {
		// 	return "ផុតកំណត់";
		// } else {
		// 	return "សល់ " + left + " ថ្ងៃ";
		// }
	},
	base64decode: function (encoded) {
		return new Buffer(encoded, 'base64').toString('utf8')
	},
	discountPrice(price, discount, type) {
		price = parseFloat(price);
		discount = parseFloat(discount);
		let discounted_price;
		if (type == 'p') {
			discounted_price = price - (price * discount / 100);
			discounted_price = discounted_price.toFixed(2);
			return discounted_price;
		} else if (type == 'm') {
			discounted_price = price - discount;
			if (discounted_price < 0) {
				discounted_price = 0;
			}
			return discounted_price;
		} else {
			return price;
		}
	},
	getLanguage(code) {
		if(String(code) == "0") {
			return 0;
		} else if (String(code) == "1") {
			return 1;
		} else if (String(code) == "2") {
			return 2;
		} else {
			return 0;
		}
	},
	validateUsername(string) {
		let array = String(string).split(" ");
		return array.join("").toLocaleLowerCase().trim();
	},
	getGameImageUrl: (id = "default") => {
		return id == "default" ? `https://msc-storage.oss-ap-southeast-1.aliyuncs.com/transactions/default.jpg?x-oss-process=style/profile-image` : `https://msc-storage.oss-ap-southeast-1.aliyuncs.com/games/${id}.jpg?x-oss-process=style/game-thumbnail`;
	},
	getTransactionUrl: (id = "default") => {
		return id == "default" ? `https://msc-storage.oss-ap-southeast-1.aliyuncs.com/transactions/default.jpg?x-oss-process=style/profile-image` : `https://msc-storage.oss-ap-southeast-1.aliyuncs.com/transactions/${id}.jpg`;
	},
	getGender(t) {
		if (t == "o") return "ផ្សេងទៀត";
		if (t == "f") return "ស្រី";
		if (t == "m") return "ប្រុស";
		return "Unknown";
	},
	getStatus(s) {
		if(s == 1) return "ដំណើរការ";
		if(s == 0) return "មិនដំណើរការ";
		if (s == "act") return "ដំណើរការ";
		if (s == "pnd") return "កំពុងរង់ចាំ";
		if (s == "pad") return "បានបង់ប្រាក់";
		if (s == "npd") return "មិនទាន់បង់ប្រាក់";
		if (s == "fin") return "បានបញ្ចប់";
		if (s == "nac") return "មិនដំណើរការ";
		if (s == "rcv") return "អ្នកទទួល";
		if (s == "snd") return "អ្នកផ្ញើរ";
		if (s == "ndv") return "មិនមានអ្នកដឹក";
		if (s == "wdv") return "រង់ចាំអ្នកដឹក";
		if (s == "dvr") return "កំពុងដឹកជញ្ជូន";
		if (s == "dlv") return "បានដល់អតិថិជន";
		if (s == "rtn") return "បានត្រឡប់";
		if(s == "sl") return "Accountant Administrator";
		if(s == "sa") return "អ្នកគ្រប់គ្រងជាន់ខ្ពស់";
		if(s == "ad") return "អ្នកគ្រប់គ្រង";
		if(s == "ca") return "Call Center Administrator";
		return "មិនមាន";
	},
	getDepositStatus(s) {
		if(s == 1) return "ជោគជ័យ";
		if(s == 0) return "កំពុងរង់ចាំ";
		if(s == 2) return "បដិសេធ";
		return "មិនមាន";
	},
	getWithdrawStatus(s) {
		if(s == 1) return "ជោគជ័យ";
		if(s == 0) return "កំពុងរង់ចាំ";
		if(s == 2) return "បដិសេធ";
		return "មិនមាន";
	},
}


export default config;



// WEBPACK FOOTER //
// ./src/config/config.js